"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.settingsStore = void 0;
const recoil_1 = require("recoil");
const storefrontSettings = (0, recoil_1.atom)({
    key: 'storefront/settings',
    default: null,
    effects: [],
});
exports.settingsStore = {
    // actual state - atoms
    storefrontSettings,
};
//# sourceMappingURL=settings.js.map